import CRMPermission from '@/models/enums/permissions/CRMPermission'
import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/settings/legal-info-pages',
    name: RouteName.LegalInfoPages,
    component: () => import('@/pages/LegalInfoPage/LegalInfoPageList.vue'),
    meta: {
      permissions: [CRMPermission.LegalInfoPagesEdit],
      breadcrumb: {
        label: 'Юридическая информация',
        parent: RouteName.Settings,
      },
    },
  },
  {
    path: '/settings/legal-info-pages/create',
    name: RouteName.LegalInfoPageCreate,
    component: () => import('@/pages/LegalInfoPage/LegalInfoPageForm.vue'),
    meta: {
      permissions: [CRMPermission.LegalInfoPagesEdit],
      breadcrumb: {
        label: 'Новая страница',
        parent: RouteName.LegalInfoPages,
      },
    },
  },
  {
    path: '/settings/legal-info-pages/:id',
    name: RouteName.LegalInfoPageEdit,
    component: () => import('@/pages/LegalInfoPage/LegalInfoPageForm.vue'),
    meta: {
      permissions: [CRMPermission.LegalInfoPagesEdit],
      breadcrumb: {
        label: 'Редактирование страницы',
        parent: RouteName.LegalInfoPages,
      },
    },
  },
]
